import { render, staticRenderFns } from "./FormBroadcast.vue?vue&type=template&id=090a8e51"
import script from "./FormBroadcast.vue?vue&type=script&lang=js"
export * from "./FormBroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports